var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6928_242835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 12.5C3.3914 12.5 3.00311 12.5 2.69683 12.3731C2.28845 12.204 1.96399 11.8795 1.79484 11.4711C1.66797 11.1649 1.66797 10.7766 1.66797 10V4.33333C1.66797 3.39991 1.66797 2.9332 1.84962 2.57668C2.00941 2.26308 2.26438 2.00811 2.57798 1.84832C2.9345 1.66666 3.40121 1.66666 4.33464 1.66666H10.0013C10.7779 1.66666 11.1662 1.66666 11.4724 1.79353C11.8808 1.96269 12.2053 2.28714 12.3744 2.69553C12.5013 3.00181 12.5013 3.39009 12.5013 4.16666M10.168 18.3333H15.668C16.6014 18.3333 17.0681 18.3333 17.4246 18.1517C17.7382 17.9919 17.9932 17.7369 18.153 17.4233C18.3346 17.0668 18.3346 16.6001 18.3346 15.6667V10.1667C18.3346 9.23324 18.3346 8.76653 18.153 8.41001C17.9932 8.09641 17.7382 7.84144 17.4246 7.68165C17.0681 7.5 16.6014 7.5 15.668 7.5H10.168C9.23455 7.5 8.76784 7.5 8.41132 7.68165C8.09771 7.84144 7.84275 8.09641 7.68296 8.41001C7.5013 8.76653 7.5013 9.23324 7.5013 10.1667V15.6667C7.5013 16.6001 7.5013 17.0668 7.68296 17.4233C7.84275 17.7369 8.09771 17.9919 8.41132 18.1517C8.76784 18.3333 9.23455 18.3333 10.168 18.3333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6928_242835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.5edde702ed5909eea0de198f7a27eba9.svg";
export { ForwardRef as ReactComponent };